import { Paths } from "../constants/UrlConstants";

const SendAnInvoiceSmartLink = {
  linkText: "Send an invoice",
  pathTo: Paths.MakeAClaim,
  iconName: "icon-functional-document",
  buttonType: ""
};

export default SendAnInvoiceSmartLink;
